export default __webpack_public_path__ + "static/media/instructor-6.24cbb915.webp";